import { Dropdown, IconButton } from "@evergis/ui";
import styled from "styled-components";

export const LayersDropdownContainer = styled.div`
  position: relative;
`;

export const LayersDropdown = styled(Dropdown)<{ withCatalog?: boolean }>`
  padding-right: ${({ withCatalog }) => (withCatalog ? "3.5rem" : "2rem")};
`;

export const CatalogButton = styled(IconButton)<{ zIndex?: number }>`
  position: absolute;
  right: 1.5rem;
  top: 1.375rem;
  z-index: ${({ zIndex }) => zIndex + 1};
`;
